'use strict';

exports.__esModule = true;
exports['default'] = contextTypes;

var _validators = require('../../utils/validators');

function contextTypes(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'contextTypes');

    // eslint-disable-next-line
    target.contextTypes = props;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/context/contextTypes.js
// module id = 564
// module chunks = 1